import NewBadge from './NewBadge';

export default NewBadge;
